<ws-client (success)="notify($event)"></ws-client>
